var map = {
	"./ebike_factory.svg": 403,
	"./efficiency_bike.svg": 404,
	"./efficiency_microchip.svg": 405,
	"./efficiency_mobile.svg": 406,
	"./facility.svg": 407,
	"./hire_employee.svg": 408,
	"./microchip_factory.svg": 409,
	"./microchip_reuse_facility.svg": 410,
	"./mobile_phone_factory.svg": 411,
	"./product_refurbishing_facility.svg": 412,
	"./product_refurbishing_facility_bike.svg": 413,
	"./rental_maintenance_service.svg": 414,
	"./rental_maintenance_service_bike.svg": 415,
	"./repair_workshop.svg": 416,
	"./substitution_bike.svg": 417,
	"./substitution_microchip.svg": 418,
	"./substitution_mobile.svg": 419,
	"./waste_recycling.svg": 420
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/investments nonrecursive ./~/raw-loader!\.svg$
// module id = 325
// module chunks = 2 5